exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-item[data-v-08a1adde]{background-color:transparent;border:none}", ""]);

// exports
